import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import FallbackSpin from '@/components/Shared/FallbackSpin';
import Meetings from '../views/meetings/Meetings';
import MeetingDetails from '../views/meetings/MeetingDetails';
import LimitsChecker from '@/components/LimitsChecker';
import AuthorizedRoute from '@/components/AuthorizedRoute';

const CompanyUpdates = lazy(() => import('@/features/companyUpdates/CompanyUpdates'));

export const InvestorRelationsRoutes = () => {
  const { search, hash } = useLocation();
  return (
    <Suspense fallback={<FallbackSpin />}>
      <Routes>
        <Route path="updates" element={<h1>Investor Relations Updates</h1>} />
        <Route path="company-updates" element={<CompanyUpdates />} />
        <Route
          path="milestones"
          element={<Navigate to={`/investor-relations/company-updates${search}${hash}`} replace />}
        />
        <Route
          element={<AuthorizedRoute allowedPermissions={['limits.meetings.manage']} isCheckOnlyCompanyPlan={true} />}
        >
          <Route element={<LimitsChecker feature="meetings" limitKeys={['limits.meetings.manage']} />}>
            <Route path="meetings" element={<Meetings />} />
          </Route>
          <Route path="meetings/:id" element={<MeetingDetails />} />
        </Route>
      </Routes>
    </Suspense>
  );
};
